export default "__VITE_ASSET__8XkwAAh2__"